import styled from 'styled-components';
import { device } from '../../../media_queries';

const MainNav = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 40px;
  margin-left: 90px;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    width: 90%;
  }
  @media ${device.desktop} {
    
  }
`;

const SummaryReport = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    width: 15%;
  }
  @media ${device.desktop} {
    
  }
`;

const ReportNav = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    width: 70%;
  }
  @media ${device.desktop} {
    
  }
`;

const ReportButton =  styled.button`
  background-color: #262237;
  color: white;
  font-size: .85em;
  font-weight: 600;
  margin: 1em;
  height: 40px;
  padding: 0.35em 1em;
  border: 2px solid gray;
  border-radius: 6px;
  cursor: pointer;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    /* width: auto; */
    /* padding-bottom: ${ props => props.active ? 20 : 15 }; */
  }
  @media ${device.desktop} {
    
  }
`;

export {
  MainNav,
  SummaryReport,
  ReportNav,
  ReportButton
};